module.exports = __webpack_public_path__ + "img/img-error.06da5cd1.png";